import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  private API = environment.apiURL + '/admin/'

  constructor(private _http: HttpClient) { }

  signInAdmin(request) {
    return this._http.post<any>(this.API + 'login', request, { observe: 'response' })
  }

  saveAdminToken(token: any) {
    localStorage.setItem('Admin-Access-Token', token);
  }

  getMerchantsByStatus(status) {
    return this._http.get<any>(this.API + 'merchants' + '?status=' + status, { observe: 'response' })
  }

  getAllMerchants() {
    return this._http.get<any>(this.API + 'merchants', { observe: 'response' })
  }

  updateMerchant(merchant_id, request) {
    return this._http.patch<any>(this.API + 'merchants/' + merchant_id, request, { observe: 'response' })
  }

  getTemplateByStatus(status, merchantId) {
    return this._http.get<any>(this.API + 'templates?status=' + status + '&merchant_id=' + merchantId, { observe: 'response' })
  }

  getTemplateByMerchantID(merchantId) {
    return this._http.get<any>(this.API + 'templates?merchant_id=' + merchantId, { observe: 'response' })
  }

  getAllTemplates() {
    return this._http.get<any>(this.API + 'templates', { observe: 'response' })
  }

  updateTemplate(merchant_id, templateName, request) {
    return this._http.patch<any>(this.API + 'merchants/' + merchant_id + '/templates/' + templateName, request, { observe: 'response' })
  }

  getBusinessInfo(merchant_id) {
    return this._http.get<any>(this.API + 'merchants/' + merchant_id + '/business/info', { observe: 'response' })
  }

  getMerchanctBusinessDocuments(merchant_id) {
    return this._http.get<any>(this.API + 'merchants/' + merchant_id + '/business/documents', { observe: 'response' })
  }

  updateBot(bot_id, request) {
    return this._http.patch<any>(this.API + 'bots/' + bot_id, request, { observe: 'response' })
  }

  getAllCompetitions(type: string) {
    let filters = {}
    if (type == "DRAFT") {
      filters = {
        status: "DRAFT"
      }
    }
    else {
      filters = {
        status: "PUBLISHED",
        expiry: type
      }
    }

    if (type == 'SCHEDULED') {
      filters = {
        expiry: type
      }
    }
    const params = new HttpParams()
      .set('limit', 1000)
      .set('filters', JSON.stringify(filters))

    return this._http.get<any>(`${this.API + 'competitions'}`, { params });
  }

  resheduleCompetition(competitionId: string, request: any) {
    return this._http.patch<any>(this.API + 'competitions/' + competitionId, request, { observe: 'response' });
  }

  getCompetitionDetails(competition_uuid) {
    return this._http.get<any>(this.API + 'competitions/' + competition_uuid, { observe: 'response' })
  }

  getCompetitionSubmission(competition_uuid, pageOffset, numberOfEntries, status, grade, state) {
    
    let filters = {};
    if (status == "SHORTLISTED") {
      filters = 
      { 
        is_shortlisted: true, 
        status: "APPROVED",
      }
    } else {
      filters = {
        status: status,
        is_shortlisted: false
      }
    }

    if(grade != 'all_class'){
      filters['grade'] = grade;
    }
    if(state != 'all_states'){
      filters['state_code'] = state;
    }

    const params = new HttpParams()
      .set('limit', numberOfEntries)
      .set('offset', pageOffset)
      .set('filters', JSON.stringify(filters))
    return this._http.get<any>(this.API + 'competitions/' + competition_uuid + '/submissions', { params });
  }

  updateSubmissionLabel(reqBody, competition_uuid) {
    return this._http.patch<any>(this.API + 'competitions/' + competition_uuid + '/submissions', reqBody);
  }

  getS3DetailsAndUpload(file, type, competition_uuid = '') {
    let endImageUrl = type;
    if (type == 'certificate')
      endImageUrl = competition_uuid + '/certificate';
    let imageType = file.type;
    if(!imageType) imageType = 'image/png'
    return this._http.post<any>(this.API + 'competitions/' + endImageUrl, { type: imageType });
  }

   uploadImageToS3(file, s3Creds) {

    const formData = new FormData();
    const fields = s3Creds.upload_details.s3_fields;
    if (fields.Key) formData.append('Key', fields.Key);
    if (fields.bucket) formData.append('bucket', fields.bucket);
    if (fields.Policy) formData.append('Policy', fields.Policy);
    if (fields['X-Amz-Algorithm']) formData.append('X-Amz-Algorithm', fields['X-Amz-Algorithm']);
    if (fields['X-Amz-Credential']) formData.append('X-Amz-Credential', fields['X-Amz-Credential']);
    if (fields['X-Amz-Date']) formData.append('X-Amz-Date', fields['X-Amz-Date']);
    if (fields['X-Amz-Signature']) formData.append('X-Amz-Signature', fields['X-Amz-Signature']);
    if (fields['X-Amz-Security-Token']) formData.append('X-Amz-Security-Token', fields['X-Amz-Security-Token']);
    if (file && file.type) formData.append('Content-Type', file.type);
    if (file) formData.append('file', file);
    const headers = new HttpHeaders();
    return this._http.post<any>(s3Creds.upload_details.url, formData, {headers, observe: 'response'});
  }

  submitCompetition(req){
    return this._http.post<any>(this.API + 'competitions', req);
  }
  submitWinners(topEntry, competitionId){
    let reqBody = {
      winners: topEntry
    }
    return this._http.put<any>(this.API + 'competitions/'+ competitionId + '/winners', reqBody);
  }

  scheduleResult(time, competitionId){
    const params = new HttpParams()
      .set('result_time', time)

    const req = {
      result_time: time
    }
      return this._http.post<any>(this.API + 'competitions/'+ competitionId + '/result', req);
  }

  getAllPosts(offset: number, limit: number, isSchedule: string, start_time?:string, end_time?:string, post_type?:string, owner_uuid?:string) {
    if (isSchedule === 'Published') {
      const params = new URLSearchParams();
      params.append('limit', limit.toString());
      params.append('offset', offset.toString());
      if (start_time) params.append('start_time', start_time);
      if (end_time) params.append('end_time', end_time);
      if (post_type) params.append('post_type', post_type);
      if (owner_uuid) params.append('owner_uuid', owner_uuid);
  
      return this._http.get<any>(`${this.API}posts?${params.toString()}`);
    } else {
      return this._http.get<any>(`${this.API}scheduled-posts?limit=${limit}&offset=${offset}`);
    }
  }
  getExportPosts(start_time?:string, end_time?:string, post_type?: string, owner_uuid?:string){
    const params = new URLSearchParams();
    if(start_time) params.append('start_time', start_time);
    if(end_time) params.append('end_time', end_time);
    if(post_type) params.append('post_type', post_type);
    if (owner_uuid) params.append('owner_uuid', owner_uuid);
    return this._http.get<any>(`${this.API}posts/export?${params.toString()}`);
  }

  getOwnerPosts(){
    return this._http.get<any>(`${this.API}posts/owners`);
  }

uploadPostMedia(fileType){
  return this._http.post<any>(`${this.API}posts/media`, {type : fileType})
 }
 postFeed(reqBody, isSchedule){
  if(!isSchedule)
    return this._http.post<any>(`${this.API}posts`, reqBody)
  else 
    return this._http.post<any>(`${this.API}scheduled-posts`, reqBody)
 }
 
 deletePost(postId, postType){
  if(postType === 'Scheduled'){
    return this._http.delete<any>(`${this.API}scheduled-posts/${postId}`)
  }
  return this._http.delete<any>(`${this.API}posts/${postId}`)
 }
 getPostDetail(postId, isSchedule){
  if(!isSchedule)
   return this._http.get<any>(`${this.API}posts/${postId}`);
  else 
  return this._http.get<any>(`${this.API}scheduled-posts/${postId}`); 
 }

 getLabels(botId){
  return this._http.get<any>(this.API + 'bots/' + botId + '/labels');
 }
 getLabelsMiniApp(mini_app_id){
  return this._http.get<any>(this.API + 'mini-apps/' + mini_app_id + '/labels');
 }
 updateLabels(botId, labels){
  return this._http.put<any>(this.API+ 'bots/'+ botId + '/labels', labels);
 }
 updateLabelsMiniapp(mini_app_id, labels){
  return this._http.put<any>(this.API+ 'mini-apps/'+ mini_app_id + '/labels', labels);
 }

 getAllBanners(limit, offset){
   return this._http.get<any>(this.API+`banners/notifications?limit=${limit}&offset=${offset}`);
 }

 updateBanner(requestBody, bannerId){
  return this._http.patch<any>(this.API+ `banners/notifications/${bannerId}`, requestBody, { observe: 'response' });
 }

 
 addBannerIcon() {
 let imageType = 'image/png'
  return this._http.post<any>(this.API + 'banners/notifications/icons', { type: imageType });
}

addNewBanner(reqBody) {
  return this._http.post<any>(this.API + "banners/notifications", reqBody)
}

getBannerDetails(bannerId){
  return this._http.get<any>(this.API+`banners/notifications/${bannerId}`)
}

getAllBannerForBannerHub(){
  return this._http.get<any>(this.API+`banners/schedules`)
}

uploadBannerHubImage(file, type){
  const formData = new FormData();
    formData.append('type', type);
    formData.append('file', file);
    return this._http.post<any>(this.API+"banners/images", formData);
}

getAllBots(){
  return this._http.get<any>(this.API+"bots");
}

scheduleBanner(reqBody){
  return this._http.post<any>(this.API + "banners/schedules", reqBody);
}




deleteCompetition(id){
  return this._http.delete<any>(this.API+`competitions/${id}`,{ observe: 'response' })
}

deactivateBanner(id){
  return this._http.delete<any>(this.API+ `banners/schedules/${id}`, { observe: 'response' });
}

rescheduleBanner(reqBody,bannerId){
  return this._http.patch<any>(this.API+ `banners/schedules/${bannerId}`, reqBody, { observe: 'response' });
}
updateMiniapp(miniAppId, reqBody){
  return this._http.patch<any>(this.API+`mini-apps/${miniAppId}`,reqBody, { observe: 'response' });
}
getCountry(){
  return this._http.get<any>(this.API + `regions/countries`, {observe: 'response'})
}
getSateWithCountry(country_code){
  return this._http.get<any>(this.API + `regions/states?country_code=${country_code}`, {observe: 'response'})
}
getCityWithCountryandState(country_code, state_code){
  return this._http.get<any>(this.API + `regions/cities?country_code=${country_code}&state_code=${state_code}`, {observe: 'response'})
}
putRegionsForMiniApp(mini_app_id, reqBody){
  return this._http.put<any>(this.API+`mini-apps/${mini_app_id}/availability/regions`,reqBody, { observe: 'response' });

}
getRegionsForMiniApp(mini_app_id){
  return this._http.get<any>(this.API + `mini-apps/${mini_app_id}/availability/regions`, {observe: 'response'})

}
putRegionsForBot(bot_id, reqBody){
  return this._http.put<any>(this.API+`bots/${bot_id}/availability/regions`,reqBody, { observe: 'response' });

}
getRegionsFoBots(bot_id){
  return this._http.get<any>(this.API + `bots/${bot_id}/availability/regions`, {observe: 'response'})

}

getAllStates(country_code){
  return this._http.get<any>(this.API + `regions/states?country_code=${country_code}`, {observe: 'response'})
}

getPollVoters(postId: string) {
  return this._http.get<any>(`${this.API}posts/${postId}/custom-responses`);
}

}


